// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"0928a167","616":"deb56711"}[chunkId] + ".chunk.js";
};